module.exports = __webpack_public_path__ + "5d0c9cb20254beb7d5f454b8e51e06af.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/franchises/dow_image_3.png
// module id = 138
// module chunks = 0